export default __webpack_public_path__ + "static/media/w6.ae396c9e.jpg";